import { LoadableLazy } from '@confluence/loadable';

export const RestrictionsUpsellDialogLoader = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-RestrictionsUpsellDialog" */ './RestrictionsUpsellDialog.tsx'
			)
		).RestrictionsUpsellDialog,
});
